<template>
  <router-link
          to="/user-management"
          class="sidebar-link sidebar-title"
          router-link-exact-active 
          v-if="checkRole(['admin'],['beacon', 'ccp'])"
        >
    <li class="level-menu outside" @click="openlevelmenu">
      <a class="nav-link" href="#">
        <feather type="users"></feather>
        <span>User</span>
      </a>
    </li>
    </router-link>
</template>

<script>
  export default {
    name: 'LevelMenu',
    data() {
      return {
        openLevelmenu: false,
      };
    },
    methods: {
      openlevelmenu() {
        this.openLevelmenu = !this.openLevelmenu;
      },
      checkRole(role,module){
        
        if(role == undefined && module== undefined){
          return false
        }
        let status_ccp=false
        let status_beacon=false
        let userinfo =localStorage.getItem("userinfo")
        userinfo=JSON.parse(userinfo)
        for(let i=0;i<module.length;i++){
          if(module[i]=="beacon"){
            if(userinfo.role_beacon == undefined){
                status_beacon=false
            }
            status_beacon= role.includes(userinfo.role_beacon);
          }
          else if(module[i]=="ccp"){
            if(userinfo.role_ccp == undefined){
              status_ccp=false
            }
            status_ccp= role.includes(userinfo.role_ccp);
          }
        }
        return (status_ccp || status_beacon)
      },
    },
  };
</script>
